import settings from "./settings";

const homeMeta = {
  keywords: 'mesoft.ae, software development companies, software development company, it solutions custom software development Dubai, custom software development UAE, custom software development Abu Dhabi, customised software, custom software development agency,software development UAE, custom software development services company, software development custom software development, visitor management solution, visitor management system, visitor management software, visitor management system for office, guest management software, visitor system, office visitor management system, guest registration software, visitor management system kiosk, visitor management kiosk systems, kiosk based visitor management system, visitor management system mobile app, data center monitoring, environmental monitoring system, server room environmental monitoring, data center environmental monitoring, meeting room solutions, meeting room manager, meeting room system, conference room booking system, conference room reservation system, meeting room reservation system, conference room system, meeting room conference system, boardroom solutions, conference hall booking system, best file sharing for small business, file sharing solutions for small business, file sharing software for business, best file sharing software for business https://www.mesoft.ae/services/customized-software/ تطوير برمجيات مخصصة  شركة تطوير برمجيات مخصصةبرمجيات مخصصةوكالةتطوير برمجيات مخصصة شركة خدمات تطوير برمجيات مخصصةتطوير برمجيات\n' +
    '\n' +
    'نظام إدارة الزوار\n' +
    'برنامج إدارة الزوار\n' +
    'نظام إدارة الزوار للمكاتب\n' +
    'برنامج إدارة الضيوف\n' +
    'نظام الزوار\n' +
    'نظام إدارة زوار المكاتب\n' +
    'برنامج تسجيل الضيوف\n' +
    'نظام إدارة الزوار عبر الأكشاك\n' +
    'أنظمة أكشاك إدارة الزوار\n' +
    'نظام إدارة الزوار عبر الأكشاك\n' +
    'تطبيق جوال لنظام إدارة الزوار\n' +
    '\n' +
    'مراقبة مركز البيانات\n' +
    'نظام مراقبة البيئة\n' +
    'مراقبة بيئة غرفة الخادم\n' +
    'مراقبة بيئة مركز البيانات\n' +
    '\n' +
    'حلول غرف الاجتماعات\n' +
    'مدير غرفة الاجتماعات\n' +
    'نظام غرف الاجتماعات\n' +
    'نظام حجز غرف المؤتمرات\n' +
    'نظام حجز غرف المؤتمرات\n' +
    'نظام غرف الاجتماعات\n' +
    'نظام مؤتمرات غرف الاجتماعات\n' +
    'حلول غرف الاجتماعات\n' +
    'نظام حجز قاعات المؤتمرات\n' +
    '\n' +
    'أفضل مشاركة ملفات للشركات الصغيرة\n' +
    'حلول مشاركة ملفات للشركات الصغيرة\n' +
    'برنامج مشاركة ملفات للشركات\n' +
    'أفضل برنامج مشاركة ملفات',
  canonical: settings.domain,
  title: 'MESOFT Business Solution Software Development Company, IT, Solutions, Mobile App Development Company, Customized Software Development Company, SMS, Temperature, Environment, Data Center, Data Centre, Server Room, AKCP, EVOKO, Call, Email, Alert, Notification, Meeting Room, Board Meeting, Paperless, Visitor Management Software, VMS, File sharing and collaboration, AMC, Abudhabi | MESOFT Business Solutions Dubai UAE GCC mesoft.ae, customised software development, custom software development company, customised software, custom software development agency, custom software development services company, software development custom software development, visitor management system, visitor management software, visitor management system for office, guest management software, visitor system, office visitor management system, guest registration software, visitor management system kiosk, visitor management kiosk systems, kiosk based visitor management system, visitor management system mobile app, data center monitoring, environmental monitoring system, server room environmental monitoring, data center environmental monitoring, meeting room solutions, meeting room manager, meeting room system, conference room booking system, conference room reservation system, meeting room reservation system, conference room system, meeting room conference system, boardroom solutions, conference hall booking system, best file sharing for small business, file sharing solutions for small business, file sharing software for business, best file sharing software for business\n',
  description: 'MESOFT Business Solutions L.L.C is a leading Technology and Software Solutions Provider with years of expertise in providing cost effective and customized software solutions to various clients in the United Arab Emirates and in the GCC.',
  robots: 'index follow',
  googleSiteVerification: '-IiUP11Q_MHPo-fb9cBQO861DS2x3Fx-OOAiw7CAKkw',
}

const aboutMeta = {
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/about',
  title: 'About Us - MESOFT Business Solutions',
  description: 'Learn more about MESOFT Business Solutions, a leading Technology and Software Solutions Provider in the UAE and GCC, specializing in customized software solutions.',
  robots: 'index follow',
}

const vmsMeta = {
  title: 'Visitor Management System | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/visitor-management-software/',
  description: 'iVisita is a complete Visitor Management System that is a smart, simple and secure way to register and track your visitors. Best software company in UAE, Dubai, Abu Dhabi, Sharjah, Ajman, Ras Al Khaimah, Fujairah, Umm Al Quwain, GCC.',
  robots: 'index follow',
}

const meetingRoomMeta = {
  title: 'Meeting Room Management Solutions | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/meeting-room-solutions/',
  description: 'Meeting room management solutions.Best custom software company in UAE, Dubai, Abu Dhabi, Sharjah, Ajman, Ras Al Khaimah, Fujairah, Umm Al Quwain, GCC.',
  robots: 'index follow',
}

const paperlessBoardMeetingMeta = {
  title: 'Paperless Board Meeting Solutions | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/paperless-board-meeting/',
  description: 'Paperless Board Meeting Solutions .Best custom software company in UAE, Dubai, Abu Dhabi, Sharjah, Ajman, Ras Al Khaimah, Fujairah, Umm Al Quwain, GCC.',
  robots: 'index follow',
}

const cFlowMeta = {
  title: 'C Flow Work flow Software | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/c-flow/',
  description: 'Cflow is a workflow automation software to streamline business processes. Reduce your paperwork and avoid manual errors.Best custom software company in UAE, Dubai, Abu Dhabi, Sharjah, Ajman, Ras Al Khaimah, Fujairah, Umm Al Quwain, GCC.',
  robots: 'index follow',
}

const fileSharingMeta = {
  title: 'Files Sharing and Collaboration | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/file-cloud/',
  description: 'Secure Enterprise File Sharing and Sync, secure online file sharing, enterprise cloud storage, on-premise cloud, self-hosted cloud, endpoint backup, sync, drive, secure mobile access, online collaboration, collaboration tools, hipaa compliance, private dropbox alternative, owncloud alternative, ftp alternative, Integration with Office and Outlook, File sharing and collaboration, Secured File Sharing| MESOFT Business Solutions Dubai UAE GCC',
  robots: 'index follow',
}

const itNetworkMonitoring = {
  title: 'IT Network and Monitoring Dubai UAE | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/it-networking-reporting-appliance/',
  description: 'OmniCenter is a monitoring, alerting, and reporting appliance (physical or virtual) which provides cost-effective and easy-to-deploy application, network, and systems management. It provides a unified single view into virtually all IT components, from end-user application experience to device-level performance and capacity planning.',
  robots: 'index follow',
}

const weedsBlackBox = {
  title: 'Weeds Black Box | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/weeds-black-box-suite/',
  description: 'WEEDS Blackbox Suite is a security solution that provides all the functions necessary for creating, storing, managing, and monitoring abnormal behavior of access records for work performed in personal information processing systems. ',
  robots: 'index follow',
}

const anyDb = {
  title: 'AnyDB | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/anydb/',
  description: "A data repository for your business providing team databases, secure sharing, secure and public forms and collaboration",
  robots: 'index follow',
}

const environmentalMonitoring = {
  title: 'Environmental | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/products/environment-monitoring-system/',
  description: 'Environmental Monitoring System is a cost effective monitoring solution which helps to protect valuable IT hardware and data by remotely monitoring the data center or server room and provide alerts of an impending disaster through SMS or Email Notifications.',
  robots: 'index follow',
}

const webApplicationDevelopment = {
  title: 'Web Application Development Dubai UAE | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/services/web-application-development/',
  description: 'As the technology advances and the programming landscape changes to accomodate the worlds growing technological needs, MESOFT constantly evaluates the latest trends in the development community. We improve ourselves to provide our clients the best possible development solutions.',
  robots: 'index follow',
}

const mobileApplicationDevelopment = {
  title: 'Mobile Application Development Dubai UAE | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/services/mobile-development/',
  description: 'Mobile application development is the process of creating software apps that run on mobile devices like smartphones and tablets. These apps are designed to provide seamless performance, engaging user experiences, and access to device features like cameras, GPS, and notifications. Developers typically build mobile apps',
  robots: 'index follow',
}

const customSoftwareMeta = {
  title: 'Custom Software Development Dubai UAE | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/services/customized-software/',
  description: `${homeMeta.description} Custom Software Development Dubai UAE customized-software`,
  robots: 'index follow',
}

const erpSoftware = {
  title: 'ERP Software Development Dubai UAE | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/services/erp-solutions/',
  description: `${homeMeta.description} ERP Software Development Dubai UAE erp-solutions`,
  robots: 'index follow',
}

const careerMeta = {
  title: 'Careers | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/career',
  description: `Career at MESOFT ${homeMeta.description}`,
  robots: 'index follow',
}

const contactMeta = {
  title: 'Contact | MESOFT Business Solutions',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/contact',
  description: `Contact at MESOFT ${homeMeta.description}`,
  robots: 'index follow',
}

export {
  homeMeta,
  aboutMeta,
  vmsMeta,
  meetingRoomMeta,
  paperlessBoardMeetingMeta,
  cFlowMeta,
  fileSharingMeta,
  itNetworkMonitoring,
  weedsBlackBox,
  anyDb,
  environmentalMonitoring,
  webApplicationDevelopment,
  mobileApplicationDevelopment,
  customSoftwareMeta,
  erpSoftware,
  careerMeta,
  contactMeta
}